import { Component, DestroyRef, inject, signal } from '@angular/core';
import {
  Router,
  RouterOutlet,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError,
} from '@angular/router';
import { filter } from 'rxjs/operators';
import { SplashComponent } from './shared/ui/splash/splash.component';
import { RouteSplashComponent } from './shared/ui/route-splash/route-splash.component';
import { RouteLoaderService } from './shared/ui/services/route-loader.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, SplashComponent, RouteSplashComponent],
  template: `
    <!-- Splash inicial (o que você já usa no index + main) -->
    @if (initialSplash()) { <app-splash /> }

    <!-- Overlay suave em cada troca de rota (semi-translúcido) -->
    @if (loader.active()) { <app-route-splash /> }

    <router-outlet />
  `,
})
export class App {
  private router = inject(Router);
  readonly loader = inject(RouteLoaderService);
  private destroyRef = inject(DestroyRef);

  initialSplash = signal(true);

  constructor() {
    setTimeout(() => this.safeHideInitial(), 2000);

    let firstDone = false;

    const sub = this.router.events
      .pipe(filter(e =>
        e instanceof NavigationStart ||
        e instanceof NavigationEnd ||
        e instanceof NavigationCancel ||
        e instanceof NavigationError
      ))
      .subscribe(evt => {
        if (evt instanceof NavigationStart) {
          if (firstDone) this.loader.show();
        } else {
          this.loader.hide();
          this.safeHideInitial();
          firstDone = true;
        }
      });

    this.destroyRef.onDestroy(() => sub.unsubscribe());
  }

  private safeHideInitial() {
    if (this.initialSplash()) this.initialSplash.set(false);
  }
}
